import { register } from "./registry";
import { ask } from "./confirm";

register((root) => {
  const form = root.querySelector("[data-kit-form]");
  if (!form) return;

  // Let's assume forms get a 'dirty' state tracking
  let isDirty = false;
  form.addEventListener("input", () => isDirty = true);

  document.addEventListener("keydown", (e: Event) => {
    const ev = e as KeyboardEvent;
    // An Escape another dialog already answered (the print prompt, a picker) is not a request to leave the form.
    if (ev.key === "Escape" && !ev.defaultPrevented && !document.querySelector("dialog[open]")) {
      const form = document.querySelector("[data-kit-form]") as HTMLFormElement;
      if (!form) return;
      const listHref = form.getAttribute("data-kit-list");
      if (!listHref) return;
      // 06 §1: on a dirty form only Y discards (the dialog starts on No)
      if (isDirty) { void ask("Discard changes?").then((yes) => { if (yes) window.location.href = listHref; }); return; }
      window.location.href = listHref;
    }
  });
});
